import {
  ISwatchColorPickerStyleProps,
  ISwatchColorPickerStyles,
} from "@fluentui/react/lib/SwatchColorPicker";

export const getStyles = (
  props: ISwatchColorPickerStyleProps
): ISwatchColorPickerStyles => {
  const { className } = props;
  return {
    root: [
      {
        padding: 3,
        margin: 4,
        outline: "none",
        borderSpacing: "0",
        borderCollapse: "collapse",
        selectors: {
          ".ms-Button-flexContainer": {
            justifyContent: "center",
          },
        },
      },
      className,
    ],
    tableCell: {
      padding: 0,
    },
  };
};
